(function ($, root, undefined) {

  $(function () {

    'use strict';

    // https://github.com/miguel-perez/smoothState.js
    var $body = $('body');
    var $loader = $('#loader');
    var $transition = $('.transition-box');

    var $page = $('#main'),
    options = {
      debug: true,
      blacklist: ".no-smoothstate, a[href*='.jpg'], a[href*='.png'], a[href*='.jpeg'], a[href*='.pdf']",
      prefetch: false,
      loadingClass: 'onload',
      scroll: true,
      cacheLength: 0,
      forms: 'search',
      onStart: {
        duration: 0, // Duration of our animation
        render: function ($container) {
          // Add your CSS animation reversing class
          // $container.addClass('onload');
          // $loader.addClass("start");
          // Restart your animation
          smoothState.restartCSSAnimations();
          $body.addClass("beforeload");
        }
      },
      onProgress: {
        // How long this animation takes
        duration: 100,
        // A function that dictates the animations that take place
        render: function ($container) {
          $body.removeClass("loaded");
          $transition.addClass("moving-effect");
          $body.removeClass("beforeload");
          // $body.addClass("onload");
        }
      },
      onReady: {
        duration: 0,
        render: function ($container, $newContent) {
          // Remove your CSS animation reversing class
          // $container.removeClass('onload');
          // $body.removeClass("onload");
          $body.addClass("loaded");
          $transition.removeClass("moving-effect");
          // $(".wrapLoader").removeClass("loading");
          // Inject the new content
          $container.html($newContent);
          initSite();
        }
      },
      onAfter : function($container, $newContent) {
          // $body.removeClass("onload");
          // $loader.removeClass("start");
      }
    },
    smoothState = $page.smoothState(options).data('smoothState');

    // -------- End smoothState ------------


  });

})(jQuery, this);

(function($, undefined) {
    var isFired = false;
    var oldReady = jQuery.fn.ready;
    $(function() {
        isFired = true;
        $(document).ready();
    });
    jQuery.fn.ready = function(fn) {
        if(fn === undefined) {
            $(document).trigger('_is_ready');
            return;
        }
        if(isFired) {
            window.setTimeout(fn, 1);
        }
        $(document).bind('_is_ready', fn);
    };
})(jQuery);
